import config from 'config';
import network from 'utils/network';

import {
  CHECK_IF_LOGGED_IN_BEGIN,
  CHECK_IF_LOGGED_IN,
  CHECK_IF_LOGGED_IN_FAILURE,
  CHECK_IF_HAS_SUBSCRIPTION_BEGIN,
  CHECK_IF_HAS_SUBSCRIPTION,
  CHECK_IF_HAS_SUBSCRIPTION_FAILURE,
  ADD_IMPORT_BEGIN,
  ADD_IMPORT,
  ADD_IMPORT_FAILURE,
} from 'constants/actionTypes';

export const checkIfLoggedIn = () =>
  network.actionWrapper(`${config.getApiUrl()}/clients/user/isLoggedIn`, {
    begin: CHECK_IF_LOGGED_IN_BEGIN,
    success: CHECK_IF_LOGGED_IN,
    failure: CHECK_IF_LOGGED_IN_FAILURE,
  });

export const checkIfHasSubscription = () =>
  network.actionWrapper(
    `${config.getApiUrl()}/subscriptions/canUseSoftwareService/Tickmark reporting tool`,
    {
      begin: CHECK_IF_HAS_SUBSCRIPTION_BEGIN,
      success: CHECK_IF_HAS_SUBSCRIPTION,
      failure: CHECK_IF_HAS_SUBSCRIPTION_FAILURE,
    }
  );

export const addImport = () =>
  network.actionWrapper(
    `${config.getApiUrl()}/reportingtool/add/`,
    {
      begin: ADD_IMPORT_BEGIN,
      success: ADD_IMPORT,
      failure: ADD_IMPORT_FAILURE,
    },
    {
      method: 'POST',
    }
  );
